export default {"src":"/_next/static/media/linkedin.f900de64.svg","height":44,"width":44,"blurWidth":0,"blurHeight":0};